<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 21 20"
    :fill="iconColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_26433_38732)">
      <path
        d="M3.16602 0C1.78711 0 0.666016 1.12109 0.666016 2.5V11.25C0.666016 12.6289 1.78711 13.75 3.16602 13.75H5.66602V8.75C5.66602 6.67969 7.3457 5 9.41602 5H14.416V2.5C14.416 1.12109 13.2949 0 11.916 0H3.16602ZM9.41602 8.75H18.166V17.5H9.41602V8.75ZM6.91602 8.75V17.5C6.91602 18.8789 8.03711 20 9.41602 20H18.166C19.5449 20 20.666 18.8789 20.666 17.5V8.75C20.666 7.37109 19.5449 6.25 18.166 6.25H9.41602C8.03711 6.25 6.91602 7.37109 6.91602 8.75Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_26433_38732">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.666016)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: [Number, String],
    required: false,
    default: 24
  },
  height: {
    type: [Number, String],
    required: false,
    default: 24
  },
  iconColor: {
    type: String,
    required: false,
    default: '#232323'
  }
})
</script>
